import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import LoginScreen from "../containers/auth/screens/LoginScreen";
import LogOut from "../containers/auth/LogOut";
import PrivateRoute from "../containers/auth/PrivateRoute";
import DashboardScreen from "../containers/dashboard/screens/DashboardScreen";
import ConfirmacionScreen from "../containers/dashboard/screens/ConfirmacionScreen";
import AutorizacionScreen from "../containers/autorizacion/screens/AutorizacionScreen";
import DetalleAutorizacionScreen from "../containers/autorizacion/screens/DetalleAutorizacionScreen";
import VoucherScreen from "../containers/autorizacion/screens/VoucherScreen";
import VoucherGmmScreen from "../containers/autorizacion/screens/VoucherGmmScreen";
import BusquedaAutorizacionScreen from "../containers/autorizacion/screens/BusquedaAutorizacionScreen";
import ConfirmarPrecertificacionScreen from "../containers/precertificacion/screens/ConfirmarPrecertificacionScreen";
import CancelarPrecertificacionScreen from "../containers/precertificacion/screens/CancelarPrecertificacionScreen";
import CierreCuentasScreen from "../containers/ingreso/screens/CierreCuentasScreen";
import DetalleCierreCuentaScreen from "../containers/ingreso/screens/DetalleCierreCuentaScreen";
import VoucherCierreCuentaScreen from "../containers/ingreso/screens/VoucherCierreCuentaScreen";
import VoucherHonorariosScreen from "../containers/ingreso/screens/VoucherHonorariosScreen";
import BusquedaCierresCuentasScreen from "../containers/ingreso/screens/BusquedaCierresCuentasScreen";
import PacientesIngresadosScreen from "../containers/ingreso/screens/PacientesIngresadosScreen";
import HojaQuirurgicaScreen from "../containers/ingreso/screens/HojaQuirurgicaScreen";
import SolicitudesHojaQuirurgicaScreen from "../containers/ingreso/screens/SolicitudesHojaQuirurgicaScreen";
import MainLayoutStandVirtual from "../containers/stand-virtual/shared/MainLayoutStandVirtual";
import standVirtualRoutes from "../containers/stand-virtual/standVirtualRoutes";
import PrecertificacionCrearScreen from "../containers/stand-virtual/certificacion/screens/PrecertificacionCrearScreen";
import PrecertificacionesConsultarScreen from "../containers/stand-virtual/certificacion/screens/PrecertificacionesConsultarScreen";
import PrecertificacionModificarScreen from "../containers/stand-virtual/certificacion/screens/PrecertificacionModificarScreen";
import PrecertificacionVerScreen from "../containers/stand-virtual/certificacion/screens/PrecertificacionVerScreen";
import UnauthorizedScreen from "../containers/auth/screens/UnauthorizedScreen";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/login">
        <LoginScreen />
      </Route>
      <Route path="/logout">
        <LogOut />
      </Route>
      <Route exact path="/unauthorized">
        <UnauthorizedScreen />
      </Route>

      <PrivateRoute
        path="/dashboard"
        component={DashboardScreen}
      />

      <PrivateRoute
        path="/confirmacion"
        component={ConfirmacionScreen}
      />
      <PrivateRoute
        path="/autorizacion"
        component={AutorizacionScreen}
      />
      <PrivateRoute
        path="/detalle-autorizacion"
        component={DetalleAutorizacionScreen}
      />
      <PrivateRoute
        path="/voucher"
        component={VoucherScreen}
      />
      <PrivateRoute
        path="/voucher-gmm"
        component={VoucherGmmScreen}
      />
      <PrivateRoute
        path="/busqueda-autorizacion"
        component={BusquedaAutorizacionScreen}
      />
      <PrivateRoute
        path="/confirmar-precertificacion"
        component={ConfirmarPrecertificacionScreen}
      />
      <PrivateRoute
        path="/cancelar-precertificacion"
        component={CancelarPrecertificacionScreen}
      />
      <PrivateRoute
        path="/cierre-cuentas"
        component={CierreCuentasScreen}
      />
      <PrivateRoute
        path="/detalle-cierre-cuenta"
        component={DetalleCierreCuentaScreen}
      />
      <PrivateRoute
        path="/voucher-cierre-cuenta"
        component={VoucherCierreCuentaScreen}
      />
      <PrivateRoute
        path="/voucher-honorarios"
        component={VoucherHonorariosScreen}
      />
      <PrivateRoute
        path="/busqueda-cierres-cuentas"
        component={BusquedaCierresCuentasScreen}
      />
      <PrivateRoute
        path="/pacientes-ingresados"
        component={PacientesIngresadosScreen}
      />
      <PrivateRoute
        path="/hoja-quirurgica"
        component={HojaQuirurgicaScreen}
      />
      <PrivateRoute
        path="/solicitudes-hoja-quirurgica"
        component={SolicitudesHojaQuirurgicaScreen}
      />

      <PrivateRoute
        exact
        path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacionNueva.route}`}
        component={PrecertificacionCrearScreen}
      />

      <PrivateRoute
        exact
        path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacionModificar.route}`}
        component={PrecertificacionModificarScreen}
      />

      <PrivateRoute
        exact
        path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacionVer.route}`}
        component={PrecertificacionVerScreen}
      />

      <PrivateRoute
        exact
        path={`/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacion.route}`}
        component={PrecertificacionesConsultarScreen}
      />

      <PrivateRoute
        path={`/${standVirtualRoutes.base.route}`}
        component={MainLayoutStandVirtual}
        isStandVirtualOnly={true}
      />

      <Route path="/">
        <Redirect to="/login" />
      </Route>
    </Switch>
  );
}